<template>
  <v-list-tile class="sidebar-profile">
    <v-list-tile-content class="ml-3">
      <v-list-tile-title>
        <span>{{ getUser.name }} {{ getUser.lastname }}</span>
      </v-list-tile-title>
    </v-list-tile-content>
    <v-menu
      bottom
      content-class="userblock-dropdown"
      left
      nudge-right="0"
      nudge-top="-10"
      offset-y
      transition="slide-y-transition"
    >
      <v-btn
        class="ma-0"
        dark
        icon
        slot="activator"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
      <div class="dropdown-content">
        <div class="dropdown-top">
          <span class="white--text fs-14 fw-bold d-block">{{ getUser.name }} {{ getUser.lastname }}</span>
          <span class="d-block fs-12 fw-normal">{{ getUser.email }}</span>
        </div>
        <v-list class="dropdown-list">
          <template v-for="userLink in userLinks">
            <template v-if="userLink.id !== 4">
              <v-list-tile
                :key="userLink.id"
                :to="userLink.path"
              >
                <i :class="userLink.icon"></i>
                <span>{{$t(userLink.title)}}</span>
              </v-list-tile>
            </template>
            <template v-else>
              <v-list-tile
                :key="userLink.id"
                @click="logoutUser"
              >
                <i :class="userLink.icon"></i>
                <span>{{$t(userLink.title)}}</span>
              </v-list-tile>
            </template>
          </template>
        </v-list>
      </div>
    </v-menu>
  </v-list-tile>
</template>

<script>
import { getCurrentAppLayout } from 'Helpers/helpers'
import { API_LOGOUT } from '../../store/modules/auth/actions.types'
import { USER_DATA } from '../../commons/constants'
import { mapGetters } from 'vuex'

export default {
  mounted() {},
  computed: {
    ...mapGetters(['getUser'])
  },
  data() {
    return {
      userLinks: [
        {
          id: 1,
          title: 'message.userProfile',
          icon: 'ti-user mr-3 primary--text',
          path: '/profile'
        } /*,
				{
					id: 2,
					title: 'message.inbox',
					icon: 'ti-email mr-3 success--text',
					path: '/inbox'
				},
				{
					id: 3,
					title: 'message.usersList',
					icon: 'ti-bell mr-3 info--text',
					path: '/users/users-list'
				},*/,
        {
          id: 4,
          title: 'message.logOut',
          icon: 'ti-power-off mr-3 error--text'
        }
      ],
      user: {}
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem(USER_DATA))
  },
  methods: {
    logoutUser() {
      this.$store.dispatch(API_LOGOUT)
    },
    getMenuLink(path) {
      return '/' + getCurrentAppLayout(this.$router) + path
    }
  }
}
</script>
<style lang="scss" scoped>
  .dropdown-top {
    background-color: #262261 !important;
    color: #C9E2FF !important;
  }
</style>
